<template>
  <div class="spo-card spo-card-shadowed rounded pa-0 overflow-hidden bg-white">
    <div ref="enteteCoureurRef">
      <EnteteCoureur :inscription="inscription" :index="index" no-delete></EnteteCoureur>
    </div>
    <StepperInscription v-if="!isFinished" :current_step="current_step_inscription" :index="index"
      @goToStep="goToStep($event)" class="bg-spo-light">
    </StepperInscription>
    <RecapitulatifInscription v-else :inscription="inscription" :index="index" @editInscription="goToParcoursStep()"
      no-delete>
    </RecapitulatifInscription>
    <ExpandTransition :show="current_step_inscription == '1'">
      <SelectionParcours :item="inscription" :initial_commande_inscription="initial_commande_inscription"
        @goToNextStep="goToIdentityStep()">
      </SelectionParcours>
    </ExpandTransition>
    <ExpandTransition :show="current_step_inscription == '2'">
      <IdentiteCoureur :item="inscription" :ids_parcours="ids_selected_parcours"
        :initial_commande_inscription="initial_commande_inscription" @onIncoherence="display_incoherence"
        @goToNextStep="goToOptionsStep()" @goToPreviousStep="goToParcoursStep()"></IdentiteCoureur>
    </ExpandTransition>
    <ExpandTransition :show="current_step_inscription == '3'">
      <SelectionOptions :item="inscription" :index_inscription="index"
        :initial_commande_inscription="initial_commande_inscription" @goToNextStep="finishInscription()"
        @goToPreviousStep="goToIdentityStep()"></SelectionOptions>
    </ExpandTransition>


    <IncoherencePopupDialog :incoherence="incoherence_response"></IncoherencePopupDialog>

  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import IdentiteCoureur from "@/components/Inscription/IdentiteCoureur.vue";
import SelectionParcours from "@/components/Inscription/SelectionParcours.vue";
import SelectionOptions from "@/components/Inscription/SelectionOptions.vue";
import EnteteCoureur from "@/components/Inscription/InscriptionItem/EnteteCoureur.vue";
import StepperInscription from "@/components/Inscription/InscriptionItem/StepperInscription.vue";
import RecapitulatifInscription from "@/components/Inscription/InscriptionItem/RecapitulatifInscription.vue";
import ExpandTransition from "@/components/App/UI/ExpandTransition.vue";
import IncoherencePopupDialog from "@/components/Inscription/IdentiteCoureur/IncoherencePopupDialog.vue";
export default {
  props: ["item", "initial_commande_inscription"],
  components: { IdentiteCoureur, SelectionParcours, SelectionOptions, EnteteCoureur, StepperInscription, RecapitulatifInscription, ExpandTransition, IncoherencePopupDialog },

  data() {
    return {
      inscription: {},
      current_step_inscription: "1",
      dialog_incoherence: false,
      incoherence_response: {},
      index: 0,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    ids_selected_parcours() {
      let ids = [];
      for (let i = 0; i < this.inscription.list_courses.list.length; i++) {
        if (this.inscription.list_courses.list[i].selected) {
          ids.push(this.inscription.list_courses.list[i].id);
        }
      }
      return ids;
    },
    isFinished() {
      return this.inscription.finished;
    },


  },

  watch: {
    "inscription.coureur": {
      deep: true,
      handler() {
        this.inscription.coureur;
      },
    },
  },
  methods: {
    display_incoherence(response) {
      if (!this.mainStore.is_default_mode) return;
      if (response) {
        if (!response.nom_valide || !response.prenom_valide || !response.sexe_valide) {
          this.incoherence_response = response;
          this.dialog_incoherence = true;
        }
      }
    },
    goToStep(step) {
      const stepNum = parseInt(step);
      const currentNum = parseInt(this.current_step_inscription);
      if (stepNum >= currentNum) {
        return;
      }
      switch (step) {
        case "1":
          this.goToParcoursStep();
          break;
        case "2":
          this.goToIdentityStep();
          break;
        case "3":
          this.goToOptionsStep();
          break;
        case "4":
          this.finishInscription();
          break;
        default:
          break;
      }
    },
    goToParcoursStep() {
      this.inscription.finished = false;
      this.current_step_inscription = "1";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
    },
    goToIdentityStep() {
      this.inscription.finished = false;
      this.current_step_inscription = "2";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
    },

    goToOptionsStep() {
      this.current_step_inscription = "3";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
    },
    finishInscription() {
      this.inscription.finished = true;
      this.current_step_inscription = "4";
      this.bookingStore.compute_cart();
    },

  },

  created() {
    this.inscription = this.item;

    if (this.inscription.finished) {
      this.current_step_inscription = "4";
    }
    if (this.mainStore.billetterie_mode && !this.inscription.finished) {
      this.goToIdentityStep();
    }
  },
};
</script>

<style lang="scss" scoped></style>